import '../../views/list/List.css';
import { Card, CardContent, CardMedia, Typography } from '@material-ui/core';
import { Link, useParams, useLocation } from 'react-router-dom';
import { ItemDetails } from '../../data/store-data';
import React from 'react';

interface Props {
  item: ItemDetails;
}

const ListItem: React.FC<Props> = props => {
  const params = useParams<{ listId: string }>();
  const location = useLocation();

  return (
    <Link
      to={`/${location.pathname.includes('demo') ? 'demo' : 'list'}/${params.listId}/${props.item.name}`}
      className="list-item-link"
    >
      <Card className="list-item-card" elevation={3}>
        <CardMedia image={props.item.image} title={props.item.title} className="list-item-image" />
        <CardContent className="list-item-content">
          <Typography component="div" className="title">
            {props.item.title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="div">
            ${props.item.price.toFixed(2)}
          </Typography>
        </CardContent>
      </Card>
    </Link>
  );
};

export default ListItem;
